
const assert = function(condition, opt_message){
  if (!condition)
    throw new Error(opt_message || 'Assert condition is false.')
}

module.exports = {
  assert,
}
